(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name crewing.controller:AssignEventCtrl
     *
     * @description
     *
     */
    angular
        .module('crewing')
        .controller('AssignEventCtrl', AssignEventCtrl);

    function AssignEventCtrl($uibModalInstance, modalParams, MessageService, CrewingHelper, PopupManager, CrewingSelectionHelper, CommonMasterData, CommonLogicService, $q) {
        var vm = this;

        vm.model = {
            type : null,
            status : true,
            activeTab : 0,
            day: '',
            eventTypes: [],
            airportList: [],
            flightOccurringEvents: [],
            aircraftType: [],
            editEventDetails : null,
            formVal: {
            	isStartLocationRequred:false,
            	isEndLocationRequred:false,
                isShowPortal:false,
                isShowPortalEnabled:false,
                isShowPortalVisible:false,
                isEditMode : false,
                crewScheduleBlockId : '',
                crewProfileId: '',
                patternId : '',
                crewId: '',
                event: null,
                startDate: {
                    value: '',
                    isDisable: true
                },
                startTime: {
                    value: '00:00',
                    isDisable: false
                },
                endDate: {
                    value:  '',
                    isDisable: false
                },
                endTime: {
                    value: '00:00',
                    isDisable: false
                },
                startLocation: {
                    value: null,
                    isDisable: false
                },
                endLocation: {
                    value: null,
                    isDisable: false
                },
                eventOccurringFlight: {
                    value: null,
                    isDisable: false
                },
                dutyPeriod: {
                    value: '00:00',
                    isDisable: true
                },
                aircraftType: {
                    value: {
                        modelNumber:null
                    },
                    isDisable: false
                },
                isExcludeFromPayment: {
                    value: false,
                    isDisable: false
                },
                isAirportStandby: {
                    value: false,
                    isDisable: false
                },
                isRequest: {
                    value: false,
                    isDisable: false
                },
                isCallFromDayOff: {
                    value: false,
                    isDisable: false
                },
                isOffC: {
                    value: false,
                    isDisable: false
                },
                isObsFlight: {
                    value: false,
                    isDisable: false
                },
                isHideinCrewPortal: {
                    value: false,
                    isDisable: false
                },
                isOutStationOff: {
                    value: false,
                    isDisable: false
                },
                remark: {
                    value: null,
                    isDisable: false
                },
                isMoff: {
                value: false,
                isDisable: false
              }
            }
        };

        (function INIT() {
            vm.model.status = modalParams.crew.crewDTO.active;
            if(!!modalParams.isEditMode){
                vm.model.formVal.isEditMode = true;
                vm.model.type = 'Edit Event ';
                vm.model.formVal.crewProfileId =  modalParams.crew.crewDTO.crewProfileId;
                vm.model.formVal.crewId = modalParams.crew.crewId;
                var deferred = $q.defer();
                populateEditEventData(modalParams.eventDetails,deferred);
                deferred.promise.then(
                    function(){
                        loadUiData();
                    }
                );
            }else{
                vm.model.formVal.isEditMode = false;
                vm.model.type = 'Add Event ';
                vm.model.day = modalParams.day;
                vm.model.formVal.crewProfileId =  modalParams.crew.crewDTO.crewProfileId;
                vm.model.formVal.crewId = modalParams.crew.crewId;
                vm.model.formVal.startDate.value = modalParams.day.date;
                vm.model.formVal.endDate.value = modalParams.day.date;
                loadUiData();
            }
        })();

        vm.onCloseClick = function () {
            $uibModalInstance.close();
        };

        vm.onAddEventClick = function () {
            if(vm.model.status){
              updateEvent();
            }
        };

        vm.onStartDateChange = function () {
            getFlightOccurringEvents(vm.model.formVal.startDate.value);
            calculateDutyHours();
        };

        vm.onEndDateChange = function(){
            calculateDutyHours();
        };

        vm.onStartTimeChange = function(){
            calculateDutyHours();
        };

        vm.onEndTimeChange = function(){
            calculateDutyHours();
        };

        vm.onEventTypeClick = function(event){
          if(vm.model.status){
            vm.model.formVal.event = event;
            performUiChanges();
          }
        };

        function loadUiData(){
            getEvents(vm.model.formVal.startDate.value);
            getAirports();
            getAircraftTypes();
            getFlightOccurringEvents(vm.model.formVal.startDate.value);
            vm.model.formVal.isShowPortal = angular.isUndefined(modalParams.showInCrewPortalParams)?false:modalParams.showInCrewPortalParams.value;
            vm.model.formVal.isShowPortalVisible = angular.isUndefined(modalParams.showInCrewPortalParams)?false:modalParams.showInCrewPortalParams.isVisible;
            vm.model.formVal.isShowPortalEnabled = angular.isUndefined(modalParams.showInCrewPortalParams)?false:modalParams.showInCrewPortalParams.isEnabled;
        }

        function updateEvent(){
            var isContinueIllegal = true;
            var isUserConfirm = false;
            if(validateAddEventData()){
            var param = vm.model.formVal;

              var selectedCrews = CrewingSelectionHelper.getSelectedCrews();
              var isOnProbation = selectedCrews[0].crewDTO.isOnProbation;
              var crewId = selectedCrews[0].crewDTO.crewId;
              var firstName = selectedCrews[0].crewDTO.firstName;
              var lastName = selectedCrews[0].crewDTO.lastName;
              console.log(isOnProbation);
              if (isOnProbation=='Y'){
                 var details = {
                      title: 'Confirmation',
                      messages: [MessageService.MESSAGES.CREWING.CREW_PROBATION_OVERRIDE,
                         "Crew Details:",
                         "Id:" + crewId,
                         "Name: " + firstName+" "+lastName],
                      close: 'CLOSE'
                    };
                    PopupManager.openModal('CONFIRM_DIALOG', details, updateEventPopupListener);


              }else {

                var dutyStartLocation = vm.model.formVal.startLocation.value ? vm.model.formVal.startLocation.value.airPortCode : '';
                var crewProfileId = vm.model.formVal ? vm.model.formVal.crewProfileId : '';
                var dutyStartDate = vm.model.formVal.startDate ? vm.model.formVal.startDate.value : '';
                var patternId =  0;

                CrewingHelper.isViolatingDutyStartLocationtwithPreviousLocation(dutyStartLocation,
                  crewProfileId, dutyStartDate, patternId, function (updateResponse) {

                    if(!updateResponse.baseMatching) {
                      var details = {
                        title: 'Confirmation',
                        messages: [MessageService.MESSAGES.CREWING.PREVIOUS_DUTY_END_BASE_IS_DIFFERENT_FROM_THE_NEXT_DUTY_START_BASE]
                      };

                      PopupManager.openModal('CONFIRM_DIALOG', details, confirmtoProceed);

                      function confirmtoProceed(param) {
                        if (param === 'YES') {

                          CrewingHelper.assignEditEvent(vm.model.formVal,isContinueIllegal,isUserConfirm,null,null,null,
                            function (assignEventData) {
                              var param = {
                                assignEventResponse : assignEventData,
                                assignEventRequestParam :vm.model.formVal,
                                isEditMode : vm.model.formVal.isEditMode
                              };
                              $uibModalInstance.close(param);
                            },
                            function (msg) {
                              MessageService.error(msg.msg[0]);
                            }
                          );

                        }
                      }
                    } else {

                      CrewingHelper.assignEditEvent(vm.model.formVal,isContinueIllegal,isUserConfirm,null,null,null,
                        function (assignEventData) {
                          var param = {
                            assignEventResponse : assignEventData,
                            assignEventRequestParam :vm.model.formVal,
                            isEditMode : vm.model.formVal.isEditMode
                          };
                          $uibModalInstance.close(param);
                        },
                        function (msg) {
                          MessageService.error(msg.msg[0]);
                        }
                      );


                    }

                  }, function (msg) {
                    MessageService.error(msg);
                  });



              }      close: 'CLOSE'

              function updateEventPopupListener(pass) {
                if (pass == 'CANCEL' || pass == undefined){
                  return;
                }
                CrewingHelper.assignEditEvent(vm.model.formVal,isContinueIllegal,isUserConfirm,null,null,null,
                  function (assignEventData) {
                    var param = {
                      assignEventResponse : assignEventData,
                      assignEventRequestParam :vm.model.formVal,
                      isEditMode : vm.model.formVal.isEditMode
                    };
                    $uibModalInstance.close(param);
                  },
                  function (msg) {
                    MessageService.error(msg.msg[0]);
                  }
                );
              }
            }

        }
        function isExceedMaxTime(maxTime,dutyTime){
            var temp = dutyTime.split(':');
            var dutyTimeInMinute = parseInt(temp[0])*60 +parseInt(temp[1]);
            if(dutyTimeInMinute>maxTime){
                return true;
            }
            else{
                return false;
            }

        }
        function validateAddEventData(){
            var isValid = true;
            if(!vm.model.formVal.event){
                MessageService.warning(MessageService.MESSAGES.CREWING.NOT_SELECT_EVENT);
                 isValid = false;
            }
            else if(!vm.model.formVal.startDate.value ||!vm.model.formVal.startTime.value){
                MessageService.warning(MessageService.MESSAGES.CREWING.ADD_EVENT_START_DATE_TIME_ERROR);
                isValid = false;
            }
            else if(!vm.model.formVal.endDate.value ||!vm.model.formVal.endTime.value){
                MessageService.warning(MessageService.MESSAGES.CREWING.ADD_EVENT_END_DATE_TIME_ERROR);
                isValid = false;
            }
            /*else if(moment(vm.model.formVal.startDate.value+" "+vm.model.formVal.startTime.value).isBefore(vm.model.formVal.endDate.value+" "+vm.model.formVal.endTime.value)){
                MessageService.warning(MessageService.MESSAGES.CREWING.END_DATE_TIME_LESS_THAN_START_DATE_TIME);
                isValid = false;
            }*/
            else if(vm.model.formVal.event.startLocRequired && (vm.model.formVal.startLocation.value === null || vm.model.formVal.startLocation.value ===" ")){
                MessageService.warning(MessageService.MESSAGES.CREWING.START_LOCATION_ERROR);
                isValid = false;
            }

            else if(vm.model.formVal.event.acTypeRequired && (vm.model.formVal.aircraftType.value === null || vm.model.formVal.startLocation.value ===" ")){
                MessageService.warning(MessageService.MESSAGES.CREWING.AIRCRAFT_ERROR);
                isValid = false;
            }
            else if(moment(vm.model.formVal.endDate.value+" "+vm.model.formVal.endTime.value,"DD/MM/YYYY HH:mm").isBefore(moment( vm.model.formVal.startDate.value+" "+vm.model.formVal.startTime.value,"DD/MM/YYYY HH:mm"))){
                MessageService.warning(MessageService.MESSAGES.CREWING.INCORRECT_TIME);
                isValid = false;
            }
            else if(!!vm.model.formVal.event.maximumDuration && isExceedMaxTime(vm.model.formVal.event.maximumDuration,vm.model.formVal.dutyPeriod.value)){
                var message="Duration is greater than the maximum duration"+ (Math.round(parseInt(vm.model.formVal.event.maximumDuration)/60*100)/100).toFixed(2) +". (HH:MM)";
                MessageService.warning(message);
                isValid = false;
            }
            else if(vm.model.formVal.event.startLocRequired && vm.model.formVal.startLocation.value.airPortCode === undefined ){
                MessageService.warning(MessageService.MESSAGES.CREWING.START_LOCATION_ERROR2);
                isValid = false;
            }
            else if(vm.model.formVal.event.endLocationRequired && vm.model.formVal.endLocation.value.airPortCode === undefined ){
                MessageService.warning(MessageService.MESSAGES.CREWING.END_LOCATION_ERROR);
                isValid = false;
            }else if(vm.model.formVal.event.endLocRequired && (vm.model.formVal.endLocation.value === null || vm.model.formVal.endLocation.value ===" ")){
              MessageService.warning(MessageService.MESSAGES.CREWING.END_LOCATION_ERROR);
              isValid = false;
            }
            return isValid;
        }

        function populateEditEventData(eventDetails,deferred){
            CrewingHelper.getEditEventDetails(eventDetails.crewScheduleBlockId,
                function(details){
                    vm.model.editEventDetails  = details;
                    vm.model.formVal.crewScheduleBlockId = eventDetails.crewScheduleBlockId;
                    vm.model.formVal.crewProfileId = eventDetails.crewProfileId;
                    vm.model.formVal.patternId = eventDetails.patternId;
                    vm.model.formVal.startDate.value = details.selectedStartDate;
                    vm.model.formVal.startTime.value = details.selectedStartTime;
                    vm.model.formVal.endDate.value = details.selectedEndDate;
                    vm.model.formVal.endTime.value = details.selectedEndTime;
                    vm.model.formVal.isRequest.value = details.selectedIsRequest;
                    vm.model.formVal.dutyPeriod.value = CommonLogicService.getHoursByMinutes(details.selectedDutyHours);
                    vm.model.formVal.isExcludeFromPayment.value = details.selectedExcludeFromPayment;
                    vm.model.formVal.isCallFromDayOff.value = details.selectedCallFromOff;
                    vm.model.formVal.isObsFlight.value = details.selectedObsFlight;
                    vm.model.formVal.isHideinCrewPortal = details.selectedHideinCrewPortal;
                    vm.model.formVal.isOffC.value = details.selectedOffC;
                    vm.model.formVal.remark.value = details.remarks;
                    vm.model.formVal.isAirportStandby.value = details.airportStandby;
                    vm.model.formVal.isMoff.value = details.selectedMoff;
                    switch (details.eventCategoryCode){
                        case 'DUTY':{
                            vm.model.activeTab = 0;
                            break;
                        }
                        case 'LEAVE':{
                            vm.model.activeTab = 1;
                            break;
                        }
                        case 'REST':{
                            vm.model.activeTab = 2;
                            break;
                        }
                    }

                    deferred.resolve();
                },
                function(error){
                    deferred.resolve();
                    MessageService.error(error);
                }
            );
        }


        function enableOrDisable(event){
            if (!!event) {
              if (event.eventCategoryCode == 'LEAVE' && (event.eventCode == 'SLV' ||event.eventCode == 'ULV' || event.eventCode == 'SBD'
                || event.eventCode == 'USL' || event.eventCode == 'NSH')) {
                vm.model.formVal.startDate.isDisable = false;
              }else {
                vm.model.formVal.startDate.isDisable = true;
              }
                if(event.eventCategoryCode == 'LEAVE'){
                    vm.model.formVal.startTime.isDisable = false;
                    vm.model.formVal.endTime.isDisable = false;
                    vm.model.formVal.isAirportStandby.isDisable = true;
                    vm.model.formVal.isRequest.isDisable = true;
                    vm.model.formVal.isCallFromDayOff.isDisable = false;
                    vm.model.formVal.isOutStationOff.isDisable = true;
                    vm.model.formVal.isOffC.isDisable = true;
                    vm.model.formVal.isMoff.isDisable = true;
                }
                if(event.eventCategoryCode == 'LEAVE' && event.eventCode == 'OFF' ){
                    vm.model.formVal.isRequest.isDisable = false;
                    vm.model.formVal.isOutStationOff.isDisable = false;
                    vm.model.formVal.isCallFromDayOff.isDisable = true;
                    vm.model.formVal.isOffC.isDisable = false;
                  vm.model.formVal.isMoff.isDisable = false;
                }
                if(event.eventCategoryCode === 'DUTY' && (event.eventCode === 'DTR' || event.eventCode === 'MDT'
                    || event.eventCode === 'MTG' ||event.eventCode === 'OFC' || event.eventCode === 'GCA'
                    || event.eventCode ==='MED' || event.eventCode === 'OBS' || event.eventCode === 'SOD' ||event.eventCode ==='CKF')){
                    vm.model.formVal.eventOccurringFlight.isDisable =true;
                    vm.model.formVal.isAirportStandby.isDisable=true;
                    vm.model.formVal.isRequest.isDisable=true;
                    vm.model.formVal.isOutStationOff.isDisable=true;
                    vm.model.formVal.isOffC.isDisable = true;
                    vm.model.formVal.isMoff.isDisable = true;
                }
                if(event.eventCategoryCode === 'DUTY' && event.eventCode === 'SBY' ){
                    vm.model.formVal.eventOccurringFlight.isDisable =true;
                    vm.model.formVal.isRequest.isDisable=true;
                    vm.model.formVal.isOutStationOff.isDisable=true;
                    vm.model.formVal.isOffC.isDisable = true;
                    vm.model.formVal.isMoff.isDisable = true;
                }
                if(event.eventCategoryCode === 'DUTY' && ( event.eventCode === 'DHD' || event.eventCode === 'DHP'
                	|| event.eventCode === 'DHT' || event.eventCode === 'POS' )){
                    vm.model.formVal.eventOccurringFlight.isDisable =false;
                    vm.model.formVal.isAirportStandby.isDisable=true;
                    vm.model.formVal.isRequest.isDisable=true;
                    vm.model.formVal.isOutStationOff.isDisable=true;
                    vm.model.formVal.isOffC.isDisable = true;
                    vm.model.formVal.isMoff.isDisable = true;
                }

                vm.model.formVal.isStartLocationRequred=angular.isUndefined(event.startLocRequired) ? false : event.startLocRequired;
                vm.model.formVal.isEndLocationRequred = angular.isUndefined(event.endLocRequired) ? false : event.endLocRequired;

                vm.model.formVal.endLocation.isDisable = !event.endLocRequired;
                vm.model.formVal.startLocation.isDisable = !event.startLocRequired;
                vm.model.formVal.isExcludeFromPayment.isDisable = !event.excludeFromPayment;
                vm.model.formVal.aircraftType.isDisable = (!event.acTypeRequired||(vm.model.formVal.isEditMode && vm.model.formVal.event.eventCode =='SBY' && !!vm.model.formVal.aircraftType !=null ));

                if(event.eventCategoryCode === 'DUTY' && (event.eventCode === 'GCA' || event.eventCode ==='OFC' || event.eventCode ==='SOD')){
                    vm.model.formVal.startLocation.value = _.find(vm.model.airportList,{airPortCode:event.startLocation});
//                    vm.model.formVal.startLocation.isDisable =true;

                    vm.model.formVal.endLocation.value = _.find(vm.model.airportList,{airPortCode:event.endLocation});
                }
            }
        }


        function performUiChanges() {
            if (!!vm.model.formVal.event) {
                vm.model.formVal.startTime.value='00:00';
                vm.model.formVal.endTime.value='00:00';
                vm.model.formVal.aircraftType.value=null;
                vm.model.formVal.endLocation.value=null;
                vm.model.formVal.eventOccurringFlight.value=null;
                vm.model.formVal.isAirportStandby.value=false;
                vm.model.formVal.isCallFromDayOff.value=false;
                vm.model.formVal.isObsFlight.value=false;
                vm.model.formVal.isHideinCrewPortal.value=vm.model.formVal.event.hideinCrewPortal;
                vm.model.formVal.isOffC.value=false;
                vm.model.formVal.isExcludeFromPayment.value=vm.model.formVal.event.excludeFromPayment;
                vm.model.formVal.isOutStationOff.value=false;
                vm.model.formVal.startLocation.value=null;
                vm.model.formVal.isRequest.value=false;
                vm.model.formVal.remark.value=null;
                vm.model.formVal.dutyPeriod.value='00:00';
                vm.model.formVal.isStartLocationRequred=angular.isUndefined(vm.model.formVal.event.startLocRequired)?false:vm.model.formVal.event.startLocRequired;
                vm.model.formVal.isEndLocationRequred = angular.isUndefined(vm.model.formVal.event.endLocRequired)?false:vm.model.formVal.event.endLocRequired;


                vm.model.formVal.startTime.value = vm.model.formVal.event.startTime;
                vm.model.formVal.endTime.value = vm.model.formVal.event.endTime;
                if(vm.model.formVal.event.startPreviousDay){
                    var selectedDate;
                    if(vm.model.formVal.isEditMode){
                        selectedDate = moment(modalParams.eventDetails.checkInDateStr,'DD/MM/YYYY').subtract(1,'d').format('DD/MM/YYYY');
                    }else{
                        selectedDate = moment(modalParams.day.date,'DD/MM/YYYY').subtract(1,'d').format('DD/MM/YYYY');
                    }
                    vm.model.formVal.startDate.value = selectedDate;
                }
                else if(vm.model.formVal.event.eventCategoryCode === 'LEAVE'){
                    if(vm.model.formVal.isEditMode){
                        selectedDate = moment(modalParams.eventDetails.checkOutDateStr,'DD/MM/YYYY').format('DD/MM/YYYY');
                    }else{
                        selectedDate = moment(modalParams.day.date,'DD/MM/YYYY')  .format('DD/MM/YYYY');
                    }
                    vm.model.formVal.endDate.value = selectedDate;
                }else if(vm.model.formVal.event.eventCategoryCode === 'DUTY'){
                  selectedDate = moment(modalParams.day.date,'DD/MM/YYYY').format('DD/MM/YYYY');
                  vm.model.formVal.startDate.value = selectedDate;
                }


                calculateDutyHours();
                enableOrDisable(vm.model.formVal.event);
            }
        }

        function calculateDutyHours() {
            vm.model.formVal.dutyPeriod.value = CommonLogicService.calculateDutyHours(
                vm.model.formVal.startDate.value,
                vm.model.formVal.startTime.value,
                vm.model.formVal.endDate.value,
                vm.model.formVal.endTime.value,
                vm.model.formVal.event.dutyHrsPercent);
        }

        function selectEvent(allEventsObj,event_id){
            var types = Object.keys(allEventsObj);
            var tmp;
            for (var i = 0; i < types.length; i++) {
                tmp =  _.find(allEventsObj[types[i]],{event_id :event_id});
                if(!!tmp){
                    break;
                }
            }
            vm.model.formVal.event = tmp;
            enableOrDisable(vm.model.formVal.event);
        }


        function selectLocations(allAirports,eventDetails){
            vm.model.formVal.startLocation.value = _.find(allAirports,{airPortCode:eventDetails.selectedStartLoc});
            vm.model.formVal.endLocation.value =  _.find(allAirports,{airPortCode:eventDetails.selectedEndLoc});
        }

        function selectAircraftTypes(allAircraftTypes,eventDetails){
            vm.model.formVal.aircraftType.value =  _.find(allAircraftTypes,{modelNumber:eventDetails.acModelNumber});
        }

        function getEvents(startDate) {
            CrewingHelper.getEvents(
                function (events) {
                    vm.model.eventTypes = events;
                    if(!!modalParams.isEditMode){
                        selectEvent(vm.model.eventTypes,vm.model.editEventDetails.eventId);
                    }
                },
                function (msg) {
                    MessageService.error(msg)
                },
                startDate
            );
        }

        function getAirports() {
            CommonMasterData.getAirportList(
                function (airports) {
                    vm.model.airportList = airports;
                    if(!!modalParams.isEditMode){
                            selectLocations(vm.model.airportList,vm.model.editEventDetails);
                    }
                },
                function (msg) {
                    MessageService.error(msg);
                }
            );
        }

        function getAircraftTypes() {
            CommonMasterData.getAircraftTypeList(
                function (aircraftTypes) {
                    vm.model.aircraftType = aircraftTypes;
                    if(!!modalParams.isEditMode){
                        selectAircraftTypes(vm.model.aircraftType,vm.model.editEventDetails);
                    }
                },
                function (msg) {
                    MessageService.error(msg);
                }
            )
        }

        function getFlightOccurringEvents(startDate) {
            CrewingHelper.getFlightOccurringEvents(startDate,
                function (flightOccurringEvents) {
                    vm.model.flightOccurringEvents = flightOccurringEvents;
                },
                function (msg) {
                    MessageService.error(msg);
                }
            )
        }

    }
}());
